var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import cx from 'classnames';
import { useDropzone } from 'react-dropzone';
import './FileDrop.scss';
var ACCEPT = '.json,.gexf,.graphml,application/json';
export default function FileDrop(_a) {
    var onDrop = _a.onDrop;
    var dropCallback = useCallback(function (acceptedFiles) {
        onDrop(acceptedFiles[0]);
    }, []);
    var _b = useDropzone({
        onDrop: dropCallback
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    return (React.createElement("div", __assign({ className: cx('FileDrop', { 'is-dragged-over': isDragActive }) }, getRootProps()),
        React.createElement("input", __assign({}, getInputProps(), { accept: ACCEPT })),
        React.createElement("div", { className: "draggable-placeholder" },
            React.createElement("p", null,
                React.createElement("em", null,
                    "Drop here a network file to work with, or click on this box to open a dialog box.",
                    React.createElement("br", null),
                    "We currently accept only ",
                    React.createElement("strong", null, ".json"),
                    ",",
                    ' ',
                    React.createElement("strong", null, ".gexf"),
                    " and ",
                    React.createElement("strong", null, ".graphml"),
                    " files.")),
            React.createElement("p", { className: cx('drop-prompt', { active: isDragActive }) },
                React.createElement("strong", null, "Ready to import !")))));
}
